export const invokeOrRenderChildren = ({ children, callWith }) =>
  typeof children === 'function' ? children(callWith) : children;

export const setHOCAndWrappedComponentName = (HOC, wrappedComponent) => {
  const wrappedComponentName =
    wrappedComponent.displayName || wrappedComponent.name || 'UnknownComponent';

  wrappedComponent.displayName = wrappedComponentName;
  HOC.displayName = `${HOC.name}(${wrappedComponentName})`;
};
